import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UrlService } from 'app/core/http/url.service';
import { DemoCoursesModel } from 'app/shared/models/demo-courses.model';
import { LoginTokenModelWithClass } from 'app/shared/models/login-token-model-with-class';
import { TransientTeacherRegistrationModel } from 'app/shared/models/transient-teacher-registration.model';

@Injectable({
  providedIn: 'root'
})
export class TeacherRegistrationDataService {
  readonly httpClient = inject(HttpClient);
  readonly urlService = inject(UrlService);

  public getDemoCourses(localeId: string): Observable<DemoCoursesModel> {
    const url = this.urlService.buildServerApiUrl('Teacher/Registration/DemoCourses', localeId);

    return this.httpClient.get<DemoCoursesModel>(url);
  }

  public registerForFreeGameShow(model: TransientTeacherRegistrationModel): Observable<LoginTokenModelWithClass> {
    const url = this.urlService.buildServerApiUrl('Teacher/Registration/RegisterTransient');

    return this.httpClient.post<LoginTokenModelWithClass>(url, model);
  }
}
